import { render, staticRenderFns } from "./Callbackxy.vue?vue&type=template&id=77996a50&"
import script from "./Callbackxy.vue?vue&type=script&lang=js&"
export * from "./Callbackxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports